import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f6e1b2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e1b2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6e1b2a')) {
      api.createRecord('6f6e1b2a', component.options)
    } else {
      api.reload('6f6e1b2a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f6e1b2a&scoped=true", function () {
      api.rerender('6f6e1b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/feedback/index.vue"
export default component.exports